// ** React Imports
import { useEffect, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'

// ** Next Import
import { useRouter } from 'next/router'

// ** MUI Imports
import Box from '@mui/material/Box'
import List from '@mui/material/List'

import Badge from '@mui/material/Badge'
import Drawer from '@mui/material/Drawer'
import MuiAvatar from '@mui/material/Avatar'
import ListItem from '@mui/material/ListItem'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import InputAdornment from '@mui/material/InputAdornment'

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'

import { useDispatch, useSelector } from 'react-redux'
import {
  selectMessage,
  fetchUserProfile,
  fetchChatsContacts,
  removeSelectedChat
} from 'src/store/apps/android-whatsapp'

// ** Icon Imports
import ICon from 'src/@core/components/icon'

// ** Custom Components Import

import Image from 'next/image'
import { Icon } from '@iconify/react'
import { Spin } from 'antd'
import NoData from 'src/components/NoData'

const callData = [
  {
    id: 1,
    name: 'Harry',
    number: 6163566375
  }
]

const TextMessagesSideBar = props => {
  const [scroll, setScroll] = useState(0)

  // 加载更多时的 loading 标记，供内层 ScrollWrapper 展示 Spin
  const [flag, setFlag] = useState(false)

  useEffect(() => {
    if (scroll >= 100) {
      if (store.selectedMessage.selected.length >= store.rightTotalCount) return
      dispatch(fetchUserProfile())
      setFlag(true)
      setTimeout(() => {
        setFlag(false)
      }, 1000)
    }
  }, [scroll])

  const ScrollWrapper = ({ children, hidden }) => {
    const store = useSelector(state => state.androidWhatsapp)

    const dispatch = useDispatch()

    if (hidden) {
      return (
        <Box sx={{ height: '100%', overflow: 'auto' }}>
          <PerfectScrollbar
            options={{ wheelPropagation: false }}
            onScrollY={(e) => {
              setScroll((e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0))
            }}
          >
            {children}
            {flag ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : null}
          </PerfectScrollbar>
        </Box>
      )
    } else {
      return (
        <PerfectScrollbar
          options={{ wheelPropagation: false }}
          onScrollY={(e) => {
            setScroll((e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0))
          }}
        >
          {children}
          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}
        </PerfectScrollbar>
      )
    }
  }

  const { t } = useTranslation('common')

  // ** Props
  const {
    store,
    hidden,
    mdAbove,
    dispatch,
    selectMessage,
    sidebarWidth,
    leftSidebarOpen,
    handleLeftSidebarToggle,
    calls,
    setCalls,
    headImg,
    setHaedImg,
    setChat,
    setContacts,
    contacts
  } = props

  // ** States
  const [query, setQuery] = useState('')
  const [filteredChat, setFilteredChat] = useState([])
  const [filteredContacts, setFilteredContacts] = useState([])
  const [active, setActive] = useState(null)

  // ** Hooks
  const router = useRouter()

  const handleChatClick = (type, chatid, item) => {
    setActive({ type, chatid })
    if (JSON.parse(localStorage.getItem('androidWhatsappItem')).chatid == chatid) return
    dispatch(selectMessage(item))
    localStorage.setItem('androidWhatsappItem', JSON.stringify(item))

    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const hasActiveId = chatid => {
    if (store.chats !== null) {
      const arr = store.chats.filter(i => i.chatid === chatid)

      return !!arr.length
    }
  }

  const callHandler = () => {
    setChat(false)
    setContacts(false)
    setCalls(true)
  }

  const contactsHandler = () => {
    setChat(false)
    setCalls(false)
    setContacts(true)
  }

  const ChatHandler = () => {
    setChat(true)
    setCalls(false)
    setContacts(false)
  }

  const renderChats = () => {
    if (store && store.list && store.list.length) {
      let data = []
      if (query.length > 0 && filteredChat.length > 0) {
        data = filteredChat
      } else {
        data = store.list
      }

      return data.map((item, index) => {
        const activeCondition = active !== null && active.chatid === item.chatid && active.type === 'messages'

        return (
          <ListItem key={index} disablePadding sx={{ '&:not(:last-child)': { mb: 1.5 } }}>
            <ListItemButton
              disableRipple
              onClick={() => handleChatClick('messages', item.chatid, item)}
              sx={{
                px: 2.5,
                py: 2.5,
                width: '100%',
                borderRadius: 1,
                alignItems: 'flex-start',
                ...(activeCondition && { backgroundColor: theme => `${theme.palette.primary.main} !important` })
              }}
            >
              <ListItemAvatar sx={{ m: 0 }}>
                <Badge
                  overlap='circular'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                >
                  <MuiAvatar
                    src={item.avata != '' ? item.avata : item.defaultAvata}
                    sx={{
                      width: 40,
                      height: 40,
                      outline: theme => `2px solid ${activeCondition ? theme.palette.common.white : 'transparent'}`
                    }}
                  />
                </Badge>
              </ListItemAvatar>
              <ListItemText
                sx={{
                  my: 0,
                  ml: 4,
                  mr: 1.5,
                  '& .MuiTypography-root': { ...(activeCondition && { color: 'common.white' }) }
                }}
                primary={
                  <Typography noWrap sx={{ ...(!activeCondition ? { color: 'text.secondary' } : {}) }}>
                    {item.subject}
                  </Typography>
                }
                secondary={
                  <Typography noWrap variant='body2' sx={{ ...(!activeCondition && { color: 'text.disabled' }) }}>
                    {item.snippet}
                  </Typography>
                }
              />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  flexDirection: 'column',
                  justifyContent: 'flex-start'
                }}
              >
                <Typography
                  sx={{
                    whiteSpace: 'nowrap',
                    color: activeCondition ? 'common.white' : 'text.disabled',
                    fontSize: '13px'
                  }}
                >
                  <>{item.time}</>
                </Typography>
              </Box>
            </ListItemButton>
          </ListItem>
        )
      })
    } else {
      return (
        <ListItem>
          <Typography sx={{ color: 'text.secondary' }}>
            <NoData />
          </Typography>
        </ListItem>
      )
    }
  }

  const handleFilter = e => {
    setQuery(e.target.value)
    if (store.list !== null && store.list.length > 0) {
      const filteredChatsArr = store.list.filter(item => {
        return item.chatid.indexOf(e.target.value) >= 0
      })

      setFilteredChat(filteredChatsArr)
    }
  }

  return (
    <div>
      <Drawer
        open={leftSidebarOpen}
        onClose={handleLeftSidebarToggle}
        variant={mdAbove ? 'permanent' : 'temporary'}
        ModalProps={{
          disablePortal: true,
          keepMounted: false // Better open performance on mobile.
        }}
        sx={{
          zIndex: 7,
          height: '100%',
          display: 'block',
          position: mdAbove ? 'static' : 'absolute',
          '& .MuiDrawer-paper': {
            boxShadow: 'none',
            overflow: 'hidden',
            width: sidebarWidth,
            position: mdAbove ? 'static' : 'absolute'
          },
          '& > .MuiBackdrop-root': {
            borderRadius: 1,
            position: 'absolute',
            zIndex: theme => theme.zIndex.drawer - 1
          }
        }}
      >
        {/* <div className='bg-[#EFEFEF] h-[60px] flex items-center w-full justify-between'>
          <div onClick={ChatHandler}></div>

          <div className='mr-4 cursor-pointer flex items-center'>
            <div onClick={callHandler} className='mr-4 text-black text-opacity-60'></div>
            <div onClick={contactsHandler} className='text-black text-opacity-60'></div>
          </div>
        </div> */}

        <Box sx={{ height: `calc(100% - 4.125rem)` }}>
          <ScrollWrapper hidden={hidden}>
            <Box sx={{ p: theme => theme.spacing(2, 3, 3) }}>
              {!mdAbove ? (
                <IconButton sx={{ p: 1, ml: 1, mt: 4 }} onClick={handleLeftSidebarToggle}>
                  <ICon icon='mdi:close' fontSize='1.375rem' />
                </IconButton>
              ) : null}

              <List sx={{ mb: 7.5, p: 0, mt: 4 }} className=''>
                {renderChats()}
              </List>
            </Box>
          </ScrollWrapper>
        </Box>
      </Drawer>
    </div>
  )
}

export default TextMessagesSideBar
